(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Lightbox = global.NewHomeSource.Lightbox || {};

  class Caption {
    /**
     * Initializes a new instance of the class.
     * Sets the initial state to null.
     */
    constructor() {
      this.state = null;
      this.currentIndex = null;
      this.eventsToObserve = {
        itemsChange: this.itemsChange.bind(this),
      };
    }

    /**
     * Initializes the object with the given state.
     *
     * @param {Object} state - The state to initialize the object with.
     * @returns {this} The current instance for chaining.
     */
    initialize(state) {
      this.state = state;
      this.addObservers();
      return this;
    }

    /**
     * Registers this instance as an observer for each event specified in `eventsToObserve`.
     * Iterates over all event keys and adds this instance as an observer to the state for each event.
     */
    addObservers() {
      Object.keys(this.eventsToObserve).forEach((event) => this.state.addObserver(event, this));
    }

    /**
     * Retrieves the lightbox description element from the root node.
     *
     * @returns {Element} The DOM element with the attribute `data-component="lightbox-description".
     */
    getDescription() {
      const rootNode = this.state.get('rootNode');
      return rootNode.querySelector('[data-component="lightbox-description"]');
    }

    /**
     * Retrieves the DOM element representing the lightbox title.
     *
     * @returns {Element} The element with the attribute `data-component="lightbox-title"`.
     */
    getTitle() {
      const rootNode = this.state.get('rootNode');
      return rootNode.querySelector('[data-component="lightbox-title"]');
    }

    /**
     * Updates the title and description elements based on the currently selected item.
     *
     * @param {Object} data - The data object containing information about the current selection.
     * @param {number} data.currentIndex - The index of the currently selected item.
     *
     * @returns {void}
     */
    itemsChange(data) {
      if (this.currentIndex === data.currentIndex) {
        return;
      }
      this.currentIndex = data.currentIndex;
      const rootNode = this.state.get('rootNode');
      const currentElement = rootNode.querySelector(`[data-column="${data.currentIndex}"]`);
      const item = this.state.findItemById(currentElement.dataset.mediaId);
      const titleElement = this.getTitle();
      const descriptionElement = this.getDescription();
      if (item) {
        titleElement.textContent = item.Title || '';
        descriptionElement.textContent = item.Description || '';
        return;
      }

      titleElement.textContent = '';
      descriptionElement.textContent = '';
    }

    /**
     * Updates the carousel by invoking the callback associated with the given topic.
     *
     * @param {*} data - The data to pass to the callback function.
     * @param {string} topic - The topic whose callback should be invoked.
     */
    update(data, topic) {
      const callback = this.eventsToObserve[topic];
      if (callback) {
        callback(data);
      }
    }

    /**
     * Removes this instance as an observer from all events listed in `eventsToObserve`.
     * Iterates over each event and calls `removeObserver` on the state object.
     */
    removeObservers() {
      Object.keys(this.eventsToObserve).forEach((event) => this.state.removeObserver(event, this));
    }

    /**
     * Cleans up resources by removing all observers associated with this instance.
     * Should be called to prevent memory leaks when the instance is no longer needed.
     */
    destroy() {
      this.removeObservers();
    }
  }

  global.NewHomeSource.Lightbox.Caption = Caption;
}(window));
